// @flow

import * as React from 'react';

import styles from './EventConsultationBanner.scss';

const PARTY = '33';
const WEDDING = '34';

export const NOT_ALLOWED_EVENT_TYPES = [PARTY, WEDDING];

const linkUrl =
  __LOCALE__ === 'fi'
    ? 'https://partnerit.venuu.fi/tapahtumakonsultti'
    : 'https://l.venuu.fi/en/eventconsultation-contact-us';

type Props = {| onClick?: () => void |};

export default function EventConsultationBanner(props: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <div className={styles.text}>
          <p>{__('search.ec_promotion.title')}</p>
          <p className={styles.ingress}>{__('search.ec_promotion.ingress')}</p>
        </div>
        <a
          href={linkUrl}
          target="_blank"
          className={styles.cta}
          onClick={props.onClick}
        >
          {__('search.ec_promotion.cta')}
        </a>
      </div>
    </div>
  );
}
